import type { ReactNode } from 'react'

import { cn } from '../../../utils/cn'
import { Text } from '../../atoms/text/text'

import { NoResultsIllustration } from './no-results-illustration'

export interface OmniTableEmptyStateProps {
  illustration?: ReactNode
  title?: ReactNode
  description?: ReactNode
  className?: string
}

export function OmniTableEmptyState({
  illustration = <NoResultsIllustration />,
  title = 'No results found',
  description = (
    <>
      We couldn't find any records matching your current filters.
      <br />
      Try again with a different word.
    </>
  ),
  className
}: OmniTableEmptyStateProps) {
  return (
    <div
      data-slot='omni-table-empty-state'
      className={cn(
        'flex h-full min-h-0 w-full flex-col items-center justify-center gap-4 px-6 py-4 text-center',
        className
      )}
    >
      {illustration && (
        <div aria-hidden className='mb-2 flex max-w-full justify-center'>
          {illustration}
        </div>
      )}
      <Text as='h3' variant='title-xl' className='text-surface-title-50'>
        {title}
      </Text>
      <Text variant='body-xl' className='text-surface-body'>
        {description}
      </Text>
    </div>
  )
}
